export const ValTypeMailgun = function valTypeMailgun(
    MailgunApi,
    $q
) {
    return {
        require: ['?ngModel', 'ngModelOptions'],
        priority: 1,
        link: function link(scope, elem, attrs, controller) {
            const ctrl = controller[0];

            if (elem.attr('type') !== 'email') {
                throw new Error('Element type is not an email.');
            }
            
            ctrl.$validators.mailGunGuard = function mailGunGuard() {
                return true;
            };

            ctrl.$validators.mailGunGuard.validationMessage = 'Please enter a valid email address.';

            ctrl.$asyncValidators.mailGunGuard = function mailGunGuard(viewValue) {
                const isMasked = scope.$eval(attrs.isMasked);

                // check Mailgun if value passes validationUtilities.isValidEmail
                if (!ctrl.$error.valTypeEmail && !ctrl.$error.mailGunGuard && ctrl.$dirty && !isMasked) {
                    return MailgunApi.check(viewValue, ctrl, elem);
                }

                return $q.resolve();
            };
        }
    };
};

ValTypeMailgun.$inject = ['MailgunApi', '$q'];
